export default __webpack_public_path__ + "static/media/portfolio4.e49deee6.jpg";